import { ShieldCheck } from "lucide-react";
import { PRODUCT_SUBNAME, DESCRIPTOR, LOGO_URL } from "@/lib/brand";

// variant: "light" (on light bg) | "onPrimary" (on blue sidebar)
export function Brand({ subtitle, descriptor = false, variant = "light", size = "md" }) {
  const onPrimary = variant === "onPrimary";
  const logoH = size === "lg" ? "h-9" : "h-7";
  const subColor = onPrimary ? "text-white" : "text-[#2563EB]";
  const subSize = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex min-w-0 items-center gap-2.5" data-testid="brand">
      <div className={`flex shrink-0 items-center ${onPrimary ? "rounded-lg bg-white px-2 py-1" : ""}`}>
        <img src={LOGO_URL} alt="TUPU" className={`${logoH} w-auto object-contain`} />
      </div>
      <div className="min-w-0 leading-tight">
        <span className={`wordmark block ${subSize} ${subColor}`}>{PRODUCT_SUBNAME}</span>
        {descriptor && <span className={`block text-[0.68rem] font-medium ${onPrimary ? "text-white/70" : "text-[#68756F]"}`}>{DESCRIPTOR}</span>}
        {subtitle && <span className={`block truncate text-xs font-normal ${onPrimary ? "text-white/70" : "text-[#68756F]"}`}>{subtitle}</span>}
      </div>
    </div>
  );
}

// Rounded square product symbol (shield/check) — same graphic language as the Stock box icon.
export function ProductSymbol({ size = "h-14 w-14" }) {
  return (
    <div className={`grid ${size} place-items-center rounded-2xl bg-[#2563EB] shadow-sm`}>
      <ShieldCheck className="h-1/2 w-1/2 text-white" />
    </div>
  );
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white px-6 py-14 text-center">
      {Icon && <Icon className="mb-3 h-10 w-10 text-slate-300" />}
      <p className="font-display text-lg font-medium text-slate-700">{title}</p>
      {subtitle && <p className="mt-1 max-w-sm text-sm text-slate-500">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
